import { useCallback, useEffect, useState } from 'react';
import { fabric } from 'fabric';
import { getStitchingManipulationRulesFromActiveSelection } from '../../../../shared/Helpers';

const RotateIncreaseAngle = 5;

function useCanvasRotation(
  canvasEl: Nullable<fabric.Canvas>,
  isRotating: boolean,
  objectModifiedHandler: (activeObjects: fabric.Object[], skipSmallMovements: boolean) => void
) {
  const [rotateOnce, setRotateOnce] = useState(true);
  const rotateActiveObject = useCallback((activeObject: fabric.Object) => {
    let angle = activeObject.get('angle');
    if (angle !== undefined) {
      angle = angle + RotateIncreaseAngle;
      activeObject.rotate(angle);
      activeObject.setCoords();
    }
  }, []);

  const rotateObject = useCallback(() => {
    if (canvasEl) {
      const activeObjects = canvasEl.getActiveObjects();
      const lockRotation = getStitchingManipulationRulesFromActiveSelection({ _objects: activeObjects }).lockRotation;
      if (!lockRotation && activeObjects.length > 0) { 
        for (const active of activeObjects) {
          rotateActiveObject(active);
        }
        canvasEl.renderAll();
        objectModifiedHandler(activeObjects, false);
      }
    }
  }, [canvasEl, objectModifiedHandler, rotateActiveObject]);

  useEffect(() => {
    if (isRotating && rotateOnce) {
      rotateObject();
      setRotateOnce(false);
    }
  }, [isRotating, rotateObject, rotateOnce]);

  useEffect(() => {
    let id: any;

    if (isRotating) {
      id = setInterval(() => {
        rotateObject();
      }, 300);
    }

    return () => {
      if (id) {
        clearInterval(id);
        setRotateOnce(true);
      }
    };
  }, [isRotating, rotateObject]);
}

export default useCanvasRotation;
